import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/start_appointments',
  component: Management,
  redirect: '/start_appointments/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/start_appointments/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listStartAppointments
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/start_appointments/ListTable'),
          meta: {
            auth: Auth.listStartAppointments,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/start_appointments/New'),
      meta: {
        auth: Auth.createStartAppointment
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/start_appointments/Edit'),
      meta: {
        auth: Auth.updateStartAppointment
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/start_appointments/DetailLayout'),
      meta: {
        auth: Auth.showStartAppointment
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/start_appointments/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showStartAppointment
          }
        }
      ]
    }
  ]
}
